import logMessage from './log-message';
import getTargetName from './get-target-name';

export default (target, key, descriptor, options) => {
  const originalGet = descriptor.get;
  const originalSet = descriptor.set;
  const newDescriptor = { ...descriptor };
  const stack = String(new Error().stack)
    .split('\n')
    .slice(2)
    .join('\n');
  if (typeof originalGet === 'function') {
    newDescriptor.get = function deprecatedGetter() {
      logMessage(
        `@DEPRECATED: The ${getTargetName(target)} getter ${key} has been deprecated. ${
          options.message
        }.\nIt will be removed as of ${options.version}\n${stack}`,
        options
      );
      return originalGet.call(this);
    };
  }
  if (typeof originalSet === 'function') {
    newDescriptor.set = function deprecatedSetter(v) {
      logMessage(
        `@DEPRECATED: The ${getTargetName(target)} setter ${key} has been deprecated. ${
          options.message
        }.\nIt will be removed as of ${options.version}\n${stack}`,
        options
      );
      return originalSet.call(this, v);
    };
  }
  Object.defineProperty(target, key, newDescriptor);
};
